import Block from '../block'

export default class Filter extends Block {
	static title = 'filter'

	init() {
		this.openFilterButton = this.getElement('open-filter')
		if (this.openFilterButton) {
			this.openFilterButton.addEventListener('click', () => this.eventEmitter.emit('filter:open-mobile-nav'))
		}
	}
}
